export enum AlertType {
  EMAIL = 'email',
  SMS = 'sms',
  PUSH = 'push',
  ERROR = 'error',
  OFF = 'off'
}
